var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1036_27513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.7551C6.03467 23.7551 0.744873 18.4653 0.744873 12C0.744873 5.53467 6.03467 0.244873 12.5 0.244873C18.9653 0.244873 24.2551 5.53467 24.2551 12C24.2551 18.4653 18.9653 23.7551 12.5 23.7551ZM12.5 2.20406C7.11222 2.20406 2.70406 6.61222 2.70406 12C2.70406 17.3877 7.11222 21.7959 12.5 21.7959C17.8877 21.7959 22.2959 17.3877 22.2959 12C22.2959 6.61222 17.8877 2.20406 12.5 2.20406Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85923 20.6205C4.61433 20.6205 4.36943 20.5225 4.17352 20.3266C3.78168 19.9347 3.78168 19.347 4.17352 18.9551L19.4062 3.67352C19.798 3.28168 20.3858 3.28168 20.7776 3.67352C21.1694 4.06535 21.1694 4.65311 20.7776 5.04494L5.59392 20.3266C5.39801 20.5225 5.15311 20.6205 4.85923 20.6205Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1036_27513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error_circle.72159b9310ef2ba14cb7b1262c9b809f.svg";
export { ForwardRef as ReactComponent };